module.exports = __webpack_public_path__ + "img/nor_qy_moun1.4cc8f6de.png";